export default "__VITE_ASSET__d2de68de__"